import { RoleFormMessages, TranslationRoleFormMessages } from "@languages/interfaces";

export const messages: TranslationRoleFormMessages = {
  [RoleFormMessages.fieldName]: "Name",
  [RoleFormMessages.fieldDescription]: "Description",
  [RoleFormMessages.createRole]: "Create group",
  [RoleFormMessages.editRole]: "Edit group",
  [RoleFormMessages.deleteRole]: "Delete group",
  [RoleFormMessages.confirmDeleteTitle]: "Delete confirmation",
  [RoleFormMessages.confirmDeleteMessage]: "Are you sure you want to delete this group?"
};